import { z } from 'zod';
import { order } from '@schuettflix/schema-registry-ts';

export const ORDER_STATUS_SCHEMA = order.orderService.versions.v1.schemas.ORDER_STATUS_SCHEMA;

export type ORDER_STATUS = z.infer<typeof ORDER_STATUS_SCHEMA>;
